"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsyncSelect = void 0;
var react_1 = require("react");
var util_1 = require("../../util");
function useAsyncSelect(loadItems, debounceMs) {
    if (debounceMs === void 0) { debounceMs = 350; }
    var _a = react_1.useState(false), loading = _a[0], setLoading = _a[1];
    var _b = react_1.useState([]), items = _b[0], setItems = _b[1];
    var load = react_1.useCallback(function (filter) {
        setLoading(true);
        loadItems(filter)
            .then(function (loadedItems) { return setItems(loadedItems); })
            .finally(function () { return setLoading(false); });
    }, [loadItems]);
    var debouncedLoad = react_1.useMemo(function () { return util_1.debounce(load, debounceMs); }, [debounceMs, load]);
    var handleFilterChange = function (filter) {
        setLoading(true);
        return debouncedLoad(filter);
    };
    return {
        getSelectProps: function () { return ({
            items: items,
            loading: loading,
            onFilterChange: handleFilterChange,
        }); },
    };
}
exports.useAsyncSelect = useAsyncSelect;
//# sourceMappingURL=useAsyncSelect.js.map